import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../../../../../global-config'
import { userSubOrderAccessorGetTrackingUrl } from '../../../../../order'

export const orderQuestionSelfServiceAccessorGetSubOrderDetailTrackingUrl = (
  config: PublicGlobalConfig,
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): string | null | undefined => {
  return userSubOrderAccessorGetTrackingUrl(config, subOrder.carrier)
}
